import { makeSx } from '@saas/lib/shared-utils'
import { palette } from '../../../utilities'

export default makeSx({
    banner: {
        width: '100%',
        padding: '1rem',
        borderWidth: '1.5px',
        borderStyle: 'solid',
        borderRadius: '0.75rem',
        alignItems: 'center',
    },
    bannerIconContainer: {
        flexShrink: 1,
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
        },
    },
    bannerContentContainer: {
        flex: 2,
        textAlign: 'left',
    },
    bannerTitle: {
        fontWeight: 700,
    },
    bannerText: {
        fontWeight: 500,
    },
    bannerButton: {
        color: palette.surface[100],
        textAlign: 'center',
        fontWeight: 700,
        fontSize: '1rem',
        lineHeight: '1.5rem',
        letterSpacing: ' 0.2px',
        display: 'flex',
        minWidth: {
            xs: 'fit-content',
            lg: '7rem',
        },
        width: 'fit-content',
        height: 'fit-content',
        padding: '0.625rem 1.5rem',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '0.625rem',
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
        },
    },
    bannerWarningContainer: {
        backgroundColor: palette.warning[50],
        borderColor: palette.warning[600],
    },
    bannerWarning: {
        color: palette.warning[600],
    },
    bannerErrorContainer: {
        backgroundColor: palette.error[100],
        borderColor: palette.error[500],
    },
    bannerError: {
        color: palette.error[500],
    },
    bannerActionButtonError: {
        backgroundColor: palette.error[500],
    },
    bannerInfoContainer: {
        backgroundColor: palette.blue[100],
        borderColor: palette.blue[500],
    },
    bannerInfo: {
        color: palette.blue[500],
    },
    bannerNeutralContainer: {
        backgroundColor: palette.surface[100],
        borderColor: palette.neutral[500],
    },
    bannerNeutral: {},
    bannerInfoButton: {
        backgroundColor: palette.blue[500],
    },
    bannerWarningButton: {
        backgroundColor: palette.warning[600],
    },
    bannerNeutralButton: {
        backgroundColor: palette.lightGrey[500],
        color: palette.typography[900],
    },
    bannerErrorButton: {
        // update colors if needed
        backgroundColor: palette.error[500],
    },
})
